const IMetricsClient = require("./IMetricsClient.js");

/**
 * Metrics client backed by the **browser** Segment snippet (`window.analytics`).
 *
 * The Segment browser SDK derives the acting user from a prior `identify()`
 * call, so `track()` ignores the explicit `userId` argument and forwards the
 * event/properties straight through. For Node.js services use
 * {@link SegmentNodeClient} instead — its analytics-node call shape carries the
 * `userId` on every call.
 */
class SegmentBrowserClient extends IMetricsClient {
  /**
   * @param {object} analytics The Segment analytics object (window.analytics).
   * @param {object} [options] See {@link IMetricsClient} (e.g. `onError`).
   */
  constructor(analytics, options = {}) {
    super(options);
    this.analytics = analytics;
  }

  track(userId, eventName, properties = {}) {
    if (!this.analytics) return;
    this.safeInvoke(() => this.analytics.track(eventName, properties));
  }

  identify(userId, traits = {}) {
    if (!this.analytics) return;
    this.safeInvoke(() => this.analytics.identify(userId, traits));
  }

  group(groupId, userId, groupTraits = {}) {
    if (!this.analytics) return;
    this.safeInvoke(() => this.analytics.group(groupId, groupTraits));
  }
}

module.exports = SegmentBrowserClient;
